/**
 * The complete list of languages supported by the translation system.
 * Single source of truth — lives in @paintscout/util so both API (server) and
 * UI (client) can import it without pulling in browser-only dependencies.
 */
export const SUPPORTED_LANGS = ['en', 'es', 'fr'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

const NON_ENGLISH_SUPPORTED_LANGS = SUPPORTED_LANGS.filter((lang) => lang !== 'en')

export function getEnabledTranslationLangs(flagValue: unknown): string[] {
  if (!Array.isArray(flagValue)) return []

  const enabledLangs = new Set(
    flagValue.filter(
      (lang): lang is (typeof NON_ENGLISH_SUPPORTED_LANGS)[number] =>
        typeof lang === 'string' &&
        NON_ENGLISH_SUPPORTED_LANGS.includes(lang as (typeof NON_ENGLISH_SUPPORTED_LANGS)[number])
    )
  )

  return NON_ENGLISH_SUPPORTED_LANGS.filter((lang) => enabledLangs.has(lang))
}
